var TrilliumConfirmationModal = (function ($) {

    var containerSelector = ".tri-confirmation-prompt";
    var confirmationModalSelector = "#triConfirmationModal";

    var checkIfContainerExists = function () {
        if ($(containerSelector) !== null &&
            $(containerSelector).length &&
            $(confirmationModalSelector) !== null &&
            $(confirmationModalSelector).length) {
            return true;
        }
        return false;
    };

    window.temporaryEvent = null;
    window.temporaryEventTarget = null;
    window.temporaryEventConfirmed = null;

    var displayConfirmationModalPrompt = function (e) {

        if (window.temporaryEventConfirmed !== true &&
            e !== null && e !== undefined &&
            e.currentTarget !== null && e.currentTarget !== undefined && e.currentTarget !== '') {

            var target = e.currentTarget;

            var title = $(target).attr('data-tri-confirmation-title');
            if (title !== undefined && title !== null && title !== '') {
                $(confirmationModalSelector).find('.modal-header h5').text(title);
            }

            var message = $(target).attr('data-tri-confirmation-message');
            if (message !== undefined && message !== null && message !== '') {
                $(confirmationModalSelector).find('.modal-body p').text(message);
            }

            window.temporaryEvent = e;
            window.temporaryEventTarget = target;
            $(confirmationModalSelector).modal('toggle');
            e.preventDefault();
            e.stopPropagation();

            $(confirmationModalSelector).on('hidden.bs.modal', function () {
                clearConfirmationModalPrompt();
            });

            return false;
        }
    };

    confirmationModalPrompt = function () {
        if (window.temporaryEvent !== undefined && window.temporaryEvent !== null &&
            window.temporaryEventTarget !== undefined && window.temporaryEventTarget !== null) {
            window.temporaryEventConfirmed = true;
            window.temporaryEventTarget.click();
            $(confirmationModalSelector).modal('hide');
        }
    };

    clearConfirmationModalPrompt = function () {
        window.temporaryEvent = null;
        window.temporaryEventTarget = null;
        window.temporaryEventConfirmed = null;
        $(confirmationModalSelector).modal('hide');
    };

    return {
        init: function () {
            if (checkIfContainerExists()) {
                $(containerSelector).on("click", function (e) {
                    displayConfirmationModalPrompt(e);
                });
            }
        },
        destroy: function () {
            $(containerSelector).off("click");
        }
    };

})(window.jQuery);

window.TrilliumConfirmationModal = TrilliumConfirmationModal;
